// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LearnitTagListResultModel from '../../model/learnit-tag-list-result-model';
import LearnitTagListResultDTO from '../dto/learnit-tag-list-result-dto';
import dtoSchema from '../schemas/learnit-tag-list-result-schema';
import LearnitTagModel from '../../model/learnit-tag-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class LearnitTagListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LearnitTagListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => LearnitTagModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: LearnitTagModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<LearnitTagListResultDTO>): LearnitTagListResultModel;
  static toModel(dto: DeepPartial<LearnitTagListResultDTO> | undefined | null): LearnitTagListResultModel | undefined;
  static toModel(dto: DeepPartial<LearnitTagListResultDTO> | undefined | null): LearnitTagListResultModel | undefined {
    return dto ? new LearnitTagListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LearnitTagListResultModel> | LearnitTagListResultModel): LearnitTagListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as LearnitTagListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LearnitTagListResultModel, can not map to LearnitTagListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
